import { useInlineNotifications } from '../../../hooks'
import { useCloseConfirm } from '../../Form'
import { FormikForm } from '../../Formik'

import { getResponsibleManagersFormValidationSchema } from './ProfileResponsibleManagersWidgetForm.utils'
import { ProfileResponsibleManagersWidgetFormFields } from './ProfileResponsibleManagersWidgetFormFields'

import * as styles from './ProfileResponsibleManagersWidgetForm.module.css'

function ProfileResponsibleManagersWidgetForm({
  FormContainer,
  fieldName,
  getPayload,
  getValidationSchema = getResponsibleManagersFormValidationSchema,
  initialValues,
  modal,
  onClose,
  onSubmit,
  onSuccess,
  ...formFieldsProps
}) {
  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  function handleSubmit(values, formikHelpers) {
    const payload = getPayload(values)

    return onSubmit(payload)
      .then(() => {
        onSuccess?.()
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  return (
    <FormikForm
      Container={FormContainer}
      containerProps={{
        isCloseConfirm,
        modal,
        setCloseConfirm,
        onClose,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getValidationSchema({
        fieldName,
        initialValues,
      })}
      onSubmit={handleSubmit}
    >
      <ProfileResponsibleManagersWidgetFormFields
        {...formFieldsProps}
        contentComponentProps={{
          className: styles.formFieldsWrapper,
        }}
        fieldName={fieldName}
        notifications={notifications}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default ProfileResponsibleManagersWidgetForm
